"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sme__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "80fa9cf8-1408-4d8f-bb00-eb7f66a44983",
    x1: 74,
    y1: 80,
    x2: 164.31,
    y2: 170.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "f4e44fd7-2740-468c-9739-f28f0c7e5abe",
    "data-name": "SME_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,28H164a8,8,0,0,1,8,8V156a16,16,0,0,1-16,16H36a16,16,0,0,1-16-16V36a8,8,0,0,1,8-8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 116,
    width: 56,
    height: 56,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 116,
    width: 56,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 114,
    width: 56,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,170H36a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H156a16,16,0,0,0,16-16v-2A16,16,0,0,1,156,170Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,156V134l-32-32H52l70,70h34A16,16,0,0,0,172,156Z",
    opacity: 0.2,
    fill: "url(#80fa9cf8-1408-4d8f-bb00-eb7f66a44983)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56,
    width: 24,
    height: 24,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 56,
    width: 24,
    height: 24,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 56,
    width: 24,
    height: 24,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56,
    width: 24,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 56,
    width: 24,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 56,
    width: 24,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,104H54a2,2,0,0,1,0-4h84a2,2,0,0,1,0,4Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 160,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,38H20a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4H172a4,4,0,0,0,4-4V34A4,4,0,0,1,172,38Z",
    opacity: 0.12
  }))), /*#__PURE__*/React.createElement("title", null, "sme-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "f16a9ac7-1ae8-4e54-b577-15edb46b2312",
    "data-name": "SME_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "4539d508-341a-4778-9b63-2cdc643d36ea",
    "data-name": "SME_ic_hi",
    width: 192,
    height: 192,
    xlinkHref: "#f4e44fd7-2740-468c-9739-f28f0c7e5abe"
  })));
}

var _default = ic_sme__dark;
exports.default = _default;